// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9473) return "static/chunks/9473.9f2ba496770929b2.js";
	if (chunkId === 1403) return "static/chunks/1403.ac551657037b296f.js";
	if (chunkId === 1943) return "static/chunks/1943.d972a25e0db17e47.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1064":"a5a70786","4959":"408e7d04","5991":"0e2d3f7a","9319":"d5e1ebe5"}[chunkId] || chunkId) + "-" + {"1064":"c2721031ab4cbe50","4959":"7d9cfc59ddda548a","5991":"92a52f5bf3b891f4","6508":"b3a0077de0a0c8ec","8497":"dec54996e304b5a3","9319":"858469692fa10d71"}[chunkId] + ".js";
};